import {createApp} from 'vue'
import VueLazyload from 'vue-lazyload'
import {router} from '@router/index'
import App from './App.vue'
import {stores} from './stores'
import './styles.scss'
// import './registerServiceWorker'
import '@vant/touch-emulator'
// Import Quick Tracking utility
import {initializeQuickTracking} from './utils/quick-tracking'

const app = createApp(App)

// stores
// - Date: 2023.09.08
// - New store, powered by Pinia
app.use(stores)

// router
app.use(router)

// VueLazyLoad
// - Date: 2023.09.08
// - Register VueLazyLoad globally
app.use(
  VueLazyload,
  {
    selector: 'img',
    loading: 'https://static.nuonuo.com.cn/zycmp/placeholder.png!thumbw440',
    error: 'https://static.nuonuo.com.cn/zycmp/placeholder.png!thumbw440',
  },
)

// Register Vue App
// - Wait for the router to resolve the initial (possibly lazy) route
//   before mounting. Otherwise the first paint runs against
//   START_LOCATION, whose `matched` is empty, so App falls back to the
//   default layout and flashes the navigation before swapping to the
//   route's real layout (e.g. the plain inspection-report pages).
// - Uses .then() rather than top-level await: the es2015 build target
//   and Android WeChat WebView do not support top-level await.
router.isReady().then(() => {
  app.mount('#app')

  // Quick Tracking
  initializeQuickTracking()
})
